<template>
  <div class="box14">
    <pageTitle title="常见问题" />

    <commomProblem :problemData="problemData" :styleData="styleData" />
    <div class="btn" @click="childMethod">咨询更多问题</div>
  </div>
</template>

<script>
import pageTitle from "../../components/common/pageTitle.vue";
import commomProblem from "../../components/common/commom-problem.vue";
export default {
  components: {
    pageTitle,
    commomProblem,
  },
  data() {
    return {
       problemData: [
        {
          title: "Java程序员转型，走技术管理方向还是架构方向好？",
          answer:[ "3年Java开发经验，技术经理和架构师岗位都有招聘，技术经理岗稍多，两个岗位薪资基本持平；5年经验，同样都有招聘，岗位数量基本持平，但薪资上架构师要高出一截。","所以结论很明朗：架构师发展起来后劲更足，单纯的管理会继续走向瓶颈。"]
           
        },
        {
          title: "学完后达到什么样的水平？",
          answer:["课程对标阿里P7核心能力，快速进阶Java架构师。"] 
        },
        {
          title: "提供就业机会或者推荐就业吗？",
          answer:[ "从简历指导、面试到试用期辅导，我们提供全套的就业服务，详情请咨询老师。"]
           
        }
      ],
      styleData: {
        iconQuestion: require("../../assets/common/question.png"),
      },
    };
  },
  methods: {
    childMethod() {
      this.$parent.itcastClick();
    }
  },
};
</script>

<style lang="less" scoped>
.box14 {
  padding: 80px 0px 68px;
  width: 100%;
  background-image: linear-gradient(
    -30deg,
    rgba(224, 245, 255, 0.5) 0%,
    rgba(240, 250, 255, 0.5) 18%,
    rgba(255, 255, 255, 0.5) 50%,
    rgba(240, 250, 255, 0.5) 82%,
    rgba(224, 245, 255, 0.5) 100%
  );
  .btn{
    width: 400px;
    height: 78px;
    font-size: 34px;
    color: #fff;
    text-align: center;
    line-height: 78px;
    border-radius: 14px;
    background: #ff5627;
    margin: 50px auto 0;
  }
}
</style>
